<template>
  <div v-if="showCamera">
    <div>
      <video v-if="!error"
             audio="false"
             ref="video"
             id="video">
      </video>
      <div v-if="error">{{ $t('plannedService.documentSelectDialog.noCamera') }}</div>
    </div>
    <div class="d-flex flex-row justify-space-between">
      <v-btn icon
             :class="{ 'hidden' : disableCameraSwitch}"
             @click="switchCamera">
        <v-icon>mdi-camera-flip-outline</v-icon>
      </v-btn>

      <v-btn
          :disabled="this.error"
          @click="takePhoto">
        <v-icon>
          mdi-camera-iris
        </v-icon>
        {{$t('plannedService.documentSelectDialog.takePhoto')}}
      </v-btn>

      <v-btn @click="closeCamera" icon>
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>

    </div>
    <canvas ref="canvas" style="display: none;" id="canvas"/>
  </div>
</template>

<script>

export default {
  name: 'Camera',
  data() {
    return {
      showCamera: false,
      currentDocuments: [],
      facingMode: 'environment',
      disableCameraSwitch: true,
      error: null,
    };
  },
  methods: {
    openCamera() {
      this.showCamera = true;
      this.gotDevices().then(() => {
        navigator.mediaDevices
            .getUserMedia({
              video: { facingMode: 'environment' },
              audio: false,
            })
            .then((stream) => {
              this.$refs.video.srcObject = stream;
              this.$refs.video.play();
            })
            .catch((err) => {
              this.error = err;
              console.log('An error occurred: ' + err);
            });
      });
    },
    closeCamera() {
      this.showCamera = false;
      this.$refs.video?.srcObject?.getTracks().forEach(function (track) {
        track.stop();
      });
    },
    takePhoto() {
      this.showCamera = false;
      this.$refs.canvas.width = this.$refs.video.videoWidth;
      this.$refs.canvas.height = this.$refs.video.videoHeight;

      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.video, 0, 0);

      this.$refs.canvas.toBlob(
          (blobFile) => {
            if (!blobFile) {
              return;
            }

            blobFile.name = 'camara_image.jpg';
            this.$emit('photo', blobFile);
            this.closeCamera();
          },
          'image/jpg',
          1,
      );
    },
    // what kind of media inputs the device has
    gotDevices() {
      return navigator.mediaDevices.enumerateDevices().then((mediaDevices) => {
        const videoInputs = mediaDevices.filter(
            (md) => md.kind === 'videoinput',
        );
        if (videoInputs.length > 1) {
          this.disableCameraSwitch = false;
        }
        this.facingMode = videoInputs.length === 1 ? 'user' : 'environment';

        return videoInputs;
      });
    },
    // If there are multiple video inputs, allow switching
    switchCamera() {
      try {
        // Stop the current tracks
        this.$refs.video?.srcObject?.getTracks().forEach(function (track) {
          track.stop();
        });

        // Configuration for camera
        this.facingMode =
            this.facingMode === 'environment' ? 'user' : 'environment';
        const options = {
          audio: false,
          video: { facingMode: this.facingMode },
        };

        // Provide new options
        navigator.mediaDevices
            .getUserMedia(options)
            .then((stream) => {
              this.$refs.video.srcObject = null;
              this.$refs.video.srcObject = stream;
              this.$refs.video.play();
            })
            .catch(function (err) {
              console.log('An error occurred: ' + err);
            });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style>

/*
.visible {
  z-index: 99999;
}
*/
#video {
  width: 100%;
  height: 100%;
}

.hidden {
  visibility: hidden;
}

</style>
